import { Injectable } from '@angular/core';

import { ReplaySubject, Subject } from 'rxjs';

import { ActionItem, ActionPlan } from 'app/providers/storage-api/actionplan.service';
import { EnableClassTelemetry } from 'app/services/otel.service';

export interface ActionPlanInfo {
  actionPlan?: ActionPlan;
  driverName?: string;
  driverColumn?: string;
  breakdownName?: string;
  breakdownColumn?: string;
  value?: number;
  simulatedValue?: number;
}

@EnableClassTelemetry()
@Injectable()
export class ActionPlanIpdService {
  private actionPlansLoadNeededEmitter$ = new Subject<void>();
  private selectedActionPlanChangeEmitter$ = new ReplaySubject<ActionPlanInfo>();
  private actionItemsChangeEmitter$ = new ReplaySubject<ActionItem[]>();
  private twtraScoringStrategyChangeEmitter$ = new ReplaySubject<'AVERAGE' | 'BOX' | 'NPS'>();

  public onActionPlansLoadNeeded = this.actionPlansLoadNeededEmitter$.asObservable();
  public onSelectedActionPlanChanged = this.selectedActionPlanChangeEmitter$.asObservable();
  public onActionItemsChanged = this.actionItemsChangeEmitter$.asObservable();
  public onTwtraScoringStrategyChanged = this.twtraScoringStrategyChangeEmitter$.asObservable();

  constructor() {}

  public needActionPlansLoad() {
    this.actionPlansLoadNeededEmitter$.next();
  }

  public changeSelectedActionPlan(actionPlanInfo: ActionPlanInfo): void {
    this.selectedActionPlanChangeEmitter$.next(actionPlanInfo);
  }

  public changeActionItems(actionItems: ActionItem[]): void {
    this.actionItemsChangeEmitter$.next(actionItems);
  }

  public changeTwtraScoringStrategy(scoringStrategy: 'AVERAGE' | 'BOX' | 'NPS'): void {
    this.twtraScoringStrategyChangeEmitter$.next(scoringStrategy);
  }

  public reset(): void {
    this.selectedActionPlanChangeEmitter$ = new ReplaySubject<ActionPlanInfo>();
    this.onSelectedActionPlanChanged = this.selectedActionPlanChangeEmitter$.asObservable();

    this.actionItemsChangeEmitter$ = new ReplaySubject<ActionItem[]>();
    this.onActionItemsChanged = this.actionItemsChangeEmitter$.asObservable();

    this.twtraScoringStrategyChangeEmitter$ = new ReplaySubject<'AVERAGE' | 'BOX' | 'NPS'>();
    this.onTwtraScoringStrategyChanged = this.twtraScoringStrategyChangeEmitter$.asObservable();
  }
}
